export default __webpack_public_path__ + "mini_nka.png";